// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3NNYZ","search":"Settings_search__2GjSi","filter":"Settings_filter__2PLDB"};